import { render, staticRenderFns } from "./jobCategory.vue?vue&type=template&id=0aed0924&scoped=true"
import script from "./jobCategory.vue?vue&type=script&lang=js"
export * from "./jobCategory.vue?vue&type=script&lang=js"
import style0 from "./jobCategory.vue?vue&type=style&index=0&id=0aed0924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aed0924",
  null
  
)

export default component.exports